// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_UploadMediaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/whatsapp_message_templates/upload_media
 *
 * Returns the public URL (Azure Blob or local fallback) of the uploaded
 * media asset. The frontend stores it as `template_media_url` on the
 * subsequent salvar() call.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface WhatsappMessageTemplates_UploadMediaResponseDados {
media_url: string
}

export type WhatsappMessageTemplates_UploadMediaResponse = ApiResponse<WhatsappMessageTemplates_UploadMediaResponseDados>;

registerResponseContract('WhatsappMessageTemplates_UploadMediaResponse', {
  media_url: { type: 'string',  required: false },
})
